function markIfPageScrolled() {
  const body = document.body;
  const scrollPosY = window.pageYOffset;
  if (scrollPosY > 0) {
    body.classList.add('is-scroll');
  } else {
    body.classList.remove('is-scroll');
  }
}
function setupAccordionToggle() {
  const accordionHeaders = document.querySelectorAll('.accordion-heading');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      if (header.classList.contains('collapsed')) {
        // accordionHeaders.forEach((otherHeader) => {
        //     otherHeader.classList.add('collapsed');
        // });
        header.classList.remove('collapsed');
        const accordionBody = header.parentElement.querySelector('.accordion-collapse');
        accordionBody.classList.remove('collapse');
      } else {
        header.classList.add('collapsed');
        const accordionBody = header.parentElement.querySelector('.accordion-collapse');
        accordionBody.classList.add('collapse');
      }
    });
  });
}
function setupHeaderDropdownToggle() {
  const body = document.querySelector('body');
  const bodyClasses = [...body.classList];
  if (window.innerWidth >= 768 && "is-front-page" in bodyClasses) {
    return;
  }
  const header = document.querySelector('.header');
  header.addEventListener('mouseleave', () => {
    header.classList.remove('is-menu-visible');
  });
  document.body.addEventListener('touchstart', () => {
    header.classList.remove('is-menu-visible');
  });
  header.addEventListener('mouseenter', () => {
    header.classList.add('is-menu-visible');
  });
  header.addEventListener('touchstart', event => {
    header.classList.add('is-menu-visible');
    event.stopPropagation();
  });
}
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function toggleElement(elemId) {
  elem = document.getElementById(elemId);
  elem.classList.toggle("d-none");
}

window.addEventListener('DOMContentLoaded', event => {
  setupAccordionToggle();
  setupHeaderDropdownToggle();
  markIfPageScrolled();
  let donationNotice = document.getElementById('donationNotice'),
    donationCloseButton = document.getElementById('donationCloseButton');
  if (donationNotice) {
    donationCloseButton.addEventListener('click', () => {
      toggleElement(donationNotice.id);
      oneYearFromNow = new Date();
      oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
      setCookie('dontation_notice_read', true, 365);
    });
  }
});
window.addEventListener('scroll', () => {
  markIfPageScrolled();
});
